export default __webpack_public_path__ + "static/media/lomoIcon4-dark.8888073c.svg";